import {DAMAGE_DICE_MAX_VALUE} from "../../configs/damage";

// Для ближнего боя передаются УЧТЕННЫЕ кости (getMeleeCountedDiceRolls): у
// селестиалов из 4 костей это две лучшие
export const checkIfAlreadyBestMeleeCombatDamage = (diceRoll1, diceRoll2) => {
  // Не меньше лучшей грани: в записях старых партий встречается прежняя
  // лучшая грань +1
  return diceRoll1 >= DAMAGE_DICE_MAX_VALUE && diceRoll2 >= DAMAGE_DICE_MAX_VALUE;
}